module.exports = __webpack_public_path__ + "img/page-container-bg.f631d6e7.png";